import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// Templates
import PageLayout from '@/views/PageLayout.vue'

// Pages
import dashboardRouter from '@/views/dashboard/dashboardRouter'
import distanceLearningRouter from '@/views/distanceLearning/distanceLearningRouter'
import etarRouter from '@/views/etar/etarRouter'
import evalRouter from '@/views/evaluations/evalRouter'
import scheduleRouter from '@/views/schedule/scheduleRouter'

// Utility menu
import preferencesRouter from '@/views/preferences/preferencesRouter'

// Components
import JcdcError404 from '@/components/jcdc/JcdcError404.vue'
import JcdcErrorWrapper from '@/views/JcdcErrorWrapper.vue'

// Auth
// Auth code is now modular and has been moved out of the router.
import { routeGuard } from '@/router/routeGuard'

// Add Router to Vue
Vue.use(VueRouter)

///// ENTRA START /////
// Instance: Registered in ~/main.ts
// Plugin: Registered in ~/main.ts
// Config: @/services/entraAuth

const passResetUrl = 'https://aka.ms/sspr'

// callBackList = [
//   {
//     name: 'callback',
//     path: '/callback',
//     alias: ['/implicit/callback', '/login/callback'],
//     component: RedirectCallback,
//   },
// ]

///// ENTRA END ///// */

// interface routerItem {
//   name: string // Path Name
//   path: string // Router Link
//   href?: string // External Link
//   target?: '_blank' // External Link opens in a new window
//   clickEvent?: boolean // Click event to trigger a function
//   component?: unknown // Component which should be rendered
// }
// interface navItem extends routerItem {
//   meta?: {
//     title?: string // Page Title (when Page Header is in Page Layout. Remove if moved to individual pages.)
//     breadCrumb?: string // Page Breadcrumb
//     requiresAuth?: boolean // Entra Authentication
//     authorizedUsers?: number[] // User Roles with Access
//     childrenInNav?: boolean // Hides children from nav
//   }
// }

// User Roles
// 1 - Student
// 2 - Staff
// 3 - Alumni
// 4 - hasEtar
// 5 - hasEval
// 6 - hasDistanceLearning

export const homePage = dashboardRouter

export const navList = [
  ...homePage,
  ...etarRouter,
  ...evalRouter,
  ...distanceLearningRouter,
  ...scheduleRouter,
]

const error404 = [
    {
      path: '404',
      name: '404',
      component: JcdcError404,
      meta: {
        title: '404 Not Found',
      },
      props: {
        resource: 'page',
        errorCode: 404,
      },
    },
    {
      path: '403',
      name: '403',
      component: JcdcError404,
      meta: {
        title: '403 Unauthorized',
      },
      props: {
        resource: 'page',
        errorCode: 403,
      },
    },
  ],
  errorNetwork = [
    {
      path: '/network-issue',
      name: 'network-issue',
      component: JcdcErrorWrapper,
      meta: { title: 'Network Issue' },
    },
  ],
  // Utility Pages are included in the routes and use the Page Layout template
  utilityPage = [...preferencesRouter]

// Utility Links are not included in the routes
export const utilityList = [
  ...utilityPage,
  {
    name: 'Manage Password',
    props: { icon: 'mdi-lock' },
    href: passResetUrl,
    target: '_blank',
  },
  {
    name: 'Log Out',
    path: '#',
    props: { icon: 'mdi-exit-to-app' },
  },
]

//* ******************************************************************

const routes = [
    ...errorNetwork,
    {
      path: '/',
      name: 'PageLayout',
      component: PageLayout,
      redirect: '/dashboard',
      meta: { requiresAuth: true },
      children: [...navList, ...utilityPage, ...error404],
    },
    {
      path: '*',
      redirect: { name: '404' },
    },
  ],
  router = new VueRouter({
    mode: 'history',
    routes,
    // Add scrollBehavior to router. When clicking back and next, this will return the user to the section of the page they were previously viewing, instead of always back to the top. - MN
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
  })

// Redirect users trying to access a page that they are not authorized to access. - MN
// Route Guard has moved to @/router/routeGuard - ROG
routeGuard(router)

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title =
      `${store.state.appTitle} - ${to.name}` || store.state.appTitle
  })
})
export default router
